import API from "./api";

export const Logout = (configUrl: string) => {
  return API.post(`${configUrl}api/User/Logout`);
};